<template>
  <div>
    <masthead title="World Leading <em>Winemakers</em>"
              text="Indies of the UK; with a unique portfolio, efficient delivery and
              service you can count on, we welcome you to discover and order wine your customers will adore."
              background-image="producers-masthead.jpg"/>
    <producer-list/>
    <site-footer/>
  </div>
</template>

<script>
  import Masthead from '@/components/Masthead.vue'
  import SiteFooter from '@/components/SiteFooter.vue'
  import ProducerList from '@/components/ProducerList'

  export default {
    name: 'ProducersPage',
    components: {
      ProducerList,
      Masthead,
      SiteFooter
    }
  };
</script>
